export interface FilterModel {
  getGroupsCount?(): number;
  getAccountTypesCount?(): number;
  getTypesCount?(): number;
  getColumnsCount?(): number;
  scrubWorkspaceData?(): void;
  isDateFilterActive?(): boolean;
}
